import { render, staticRenderFns } from "./portalIdChange.vue?vue&type=template&id=200b2ca1"
import script from "./portalIdChange.vue?vue&type=script&lang=js"
export * from "./portalIdChange.vue?vue&type=script&lang=js"
import style0 from "./portalIdChange.vue?vue&type=style&index=0&id=200b2ca1&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('200b2ca1')) {
      api.createRecord('200b2ca1', component.options)
    } else {
      api.reload('200b2ca1', component.options)
    }
    module.hot.accept("./portalIdChange.vue?vue&type=template&id=200b2ca1", function () {
      api.rerender('200b2ca1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/login/portalIdChange.vue"
export default component.exports